export const formatTraceDuration = (durationMs: number | null): string => {
  if (durationMs === null || Number.isNaN(durationMs)) {
    return "—";
  }
  if (durationMs < 1000) {
    return `${Math.round(durationMs)}ms`;
  }
  if (durationMs < 60000) {
    return `${parseFloat((durationMs / 1000).toFixed(2))}s`;
  }
  const minutes = Math.floor(durationMs / 60000);
  const seconds = Math.round((durationMs % 60000) / 1000);
  return seconds === 0 ? `${minutes}m` : `${minutes}m ${seconds}s`;
};

export const formatTraceCost = (cost: number | null): string => {
  if (cost === null || Number.isNaN(cost)) {
    return "—";
  }
  if (cost === 0) {
    return "$0";
  }
  if (cost < 0.01) {
    return `$${cost.toFixed(4)}`;
  }
  return `$${cost.toFixed(2)}`;
};

export const formatTraceCount = (value: number | null): string => {
  if (value === null || Number.isNaN(value)) {
    return "—";
  }
  return value.toLocaleString();
};
